import { Button } from '../../components/ui/button';
import { GraduationCap, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const dashboardPaths = {
  admin: '/dashboard/admin',
  resp_peda: '/dashboard/admin',
  resp_admin: '/dashboard/admin',
  teacher: '/dashboard/teacher',
  student: '/dashboard/student',
  partner: '/dashboard/partner',
};

const Header = ({ 
  navLinks, 
  activeSection, 
  isMobileMenuOpen, 
  setIsMobileMenuOpen, 
  handleNavClick 
}) => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  return (
    <>
      {/* Header/Navbar */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <a 
              href="#" 
              onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="flex items-center shrink-0 focus:outline-none"
              data-testid="logo-link"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_ec0e6c28-2dec-4a8b-9e46-60d9bf9b919f/artifacts/brhzx1m4_Logo%20no%20background.png" 
                alt="Speak&Move Global Institute"
                className="w-[110px] md:w-[150px] lg:w-[180px] h-auto object-contain"
                style={{ marginTop: '-40px', marginBottom: '-40px' }}
              />
            </a>

            {/* Navigation - Desktop only (xl+) */}
            <nav className="hidden xl:flex items-center gap-1" role="navigation" aria-label="Navigation principale">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={(e) => handleNavClick(e, link.id)}
                  className={`px-3 py-2 text-sm font-medium rounded-lg transition-all ${
                    activeSection === link.id
                      ? 'text-primary bg-primary/10'
                      : 'text-gray-600 hover:text-primary hover:bg-gray-50'
                  }`}
                  data-testid={`nav-link-${link.id}`}
                >
                  {link.label}
                </a>
              ))}
            </nav>

            {/* CTA Buttons + Mobile Menu Toggle */}
            <div className="flex items-center gap-2">
              {isAuthenticated && user ? (
                <Button size="sm" onClick={() => navigate(dashboardPaths[user.role] || '/dashboard/admin')} className="hidden sm:flex bg-primary text-xs" data-testid="dashboard-btn">Mon espace</Button>
              ) : (
                <>
                  <Button variant="outline" size="sm" onClick={() => navigate('/rendez-vous')} className="hidden md:flex border-accent text-accent hover:bg-accent hover:text-white text-xs" data-testid="booking-btn">Prendre RDV</Button>
                  <Button variant="outline" size="sm" onClick={() => navigate('/login')} className="hidden md:flex border-secondary text-secondary hover:bg-secondary hover:text-white text-xs" data-testid="login-btn">Connexion</Button>
                  <Button size="sm" onClick={() => navigate('/register')} className="hidden md:flex bg-primary text-xs" data-testid="register-btn">S'inscrire</Button>
                </>
              )}

              {/* Hamburger - visible below xl */}
              <button
                type="button"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="xl:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100"
                aria-expanded={isMobileMenuOpen}
                aria-label={isMobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
                data-testid="mobile-menu-toggle"
              >
                {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <>
          <div className="xl:hidden fixed inset-0 z-40" onClick={() => setIsMobileMenuOpen(false)} />
          <div id="mobile-menu" className="xl:hidden fixed top-16 left-0 right-0 bg-white z-50 shadow-xl border-t border-gray-100" data-testid="mobile-menu-panel">
            <nav className="px-4 py-4 flex flex-col gap-1" role="navigation" aria-label="Navigation mobile">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  onClick={(e) => handleNavClick(e, link.id)}
                  className={`px-4 py-3 text-base font-medium rounded-xl transition-all ${
                    activeSection === link.id
                      ? 'text-primary bg-primary/10'
                      : 'text-gray-700 hover:text-primary hover:bg-gray-50'
                  }`}
                  data-testid={`mobile-nav-${link.id}`}
                >
                  {link.label}
                </a>
              ))}
              <div className="border-t border-gray-100 mt-3 pt-3 flex flex-col gap-2">
                <Button variant="outline" className="w-full border-accent text-accent" onClick={() => { navigate('/rendez-vous'); setIsMobileMenuOpen(false); }}>Prendre RDV</Button>
                <Button variant="outline" className="w-full border-secondary text-secondary" onClick={() => { navigate('/login'); setIsMobileMenuOpen(false); }}>Connexion</Button>
                <Button className="w-full bg-primary text-white" onClick={() => { navigate('/register'); setIsMobileMenuOpen(false); }}>S'inscrire</Button>
              </div>
            </nav>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
